import { render } from "./ClientListStat.vue?vue&type=template&id=351a6db2"
import script from "./ClientListStat.vue?vue&type=script&lang=js"
export * from "./ClientListStat.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__